import React from "react";
import Loader from "../../Loader";
import { formStyles } from "../formStyles";

export default function OwnerVerificationStep(props) {
  const { register, inputs, handleChange, handleSubmit, nextStep, prevStep, isLoading, profileType, states, lgs, owner, ownerDetails, setOwnerDetails, setStep } = props;

  return (
    <div className={formStyles.card}>
      <h2 className={formStyles.header}>Owner Verification</h2>
      
      {profileType === "individual" && (
        <div className="bg-slate-50 p-6 rounded-xl border border-gray-200 text-center mb-8">
          <label className="block text-lg font-bold text-slate-900 mb-4">Are you the owner of the stolen vehicle?</label>
          <div className="flex justify-center gap-8" onChange={handleChange}>
            <label className="flex items-center cursor-pointer text-lg"><input type="radio" name="owner" value="yes" required className="mr-2 w-5 h-5 text-blue-600" /> Yes</label>
            <label className="flex items-center cursor-pointer text-lg"><input type="radio" name="owner" value="no" required className="mr-2 w-5 h-5 text-blue-600" /> No, filing for someone else</label>
          </div>
        </div>
      )}

      {owner !== "" && owner !== undefined && (
        <div className="space-y-6 border-t border-gray-200 pt-6 mt-6">
          <h3 className="text-xl font-bold text-slate-800 mb-4">Owner Details</h3>
          
          {profileType === "individual" && inputs.owner === "no" && (
            <div className="w-full md:w-1/2 mb-6">
              <label className={formStyles.label}>Relationship to Owner</label>
              <input type="text" {...register("relationship", { required: inputs.owner === "no" })} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, relationship: e.target.value })} className={formStyles.input} placeholder="e.g. Brother, Employee" />
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className={formStyles.label}>Owner ID Type</label>
              <select {...register("id_type", { required: true })} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, id_type: e.target.value })} className={formStyles.input}>
                <option value="">Select ID Type</option>
                {profileType === "individual" && <option value="nin">National Identification Number (NIN)</option>}
              </select>
            </div>
            <div>
              <label className={formStyles.label}>Owner ID Number</label>
              <input type="text" name="owner_id_number" id="owner_id_number" onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, id_number: e.target.value })} className={`${formStyles.input} uppercase`} />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div>
              <label className={formStyles.label}>{profileType === "individual" ? "First Name" : "Organization Name"}</label>
              <input type="text" {...register("first_name")} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, first_name: e.target.value })} className={formStyles.input} />
            </div>
            <div>
              <label className={formStyles.label}>Middle Name</label>
              <input type="text" {...register("middle_name")} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, middle_name: e.target.value })} className={formStyles.input} />
            </div>
            <div>
              <label className={formStyles.label}>Last Name</label>
              <input type="text" {...register("last_name")} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, last_name: e.target.value })} className={formStyles.input} />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {inputs.owner !== "yes" && (
              <div>
                <label className={formStyles.label}>Gender</label>
                <select {...register("gender")} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, gender: e.target.value })} className={formStyles.input}>
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
            )}
            <div>
              <label className={formStyles.label}>Phone</label>
              <input type="text" onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, phone: e.target.value })} className={formStyles.input} />
            </div>
            <div>
              <label className={formStyles.label}>Email</label>
              <input type="email" {...register("email")} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, email: e.target.value })} className={formStyles.input} />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className={formStyles.label}>Current State</label>
              <select {...register("state", { required: true })} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, state: e.target.value })} className={formStyles.input}>
                <option value="">Select State</option>
                {states.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
              </select>
            </div>
            <div>
              <label className={formStyles.label}>Current LGA</label>
              <select {...register("lga", { required: true })} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, lga: e.target.value })} className={formStyles.input}>
                <option value="">Select LGA</option>
                {lgs.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
              </select>
            </div>
          </div>
          
          <div>
            <label className={formStyles.label}>Current Residential Address</label>
            <input type="text" {...register("present_address")} onChangeCapture={(e)=>setOwnerDetails({ ...ownerDetails, present_adddress: e.target.value })} onChange={handleChange} className={formStyles.input} />
          </div>
        </div>
      )}

      <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-200">
        <button type="button" onClick={() => profileType === "corporate" ? setStep(10) : prevStep()} className={formStyles.buttonSecondary}>&laquo; Previous</button>
        <button type="button" onClick={handleSubmit(nextStep)} className={formStyles.buttonPrimary}>
          Next &raquo; {isLoading && <span className="ml-2"><Loader /></span>}
        </button>
      </div>
    </div>
  );
}